<template>
    <v-dialog width="500" v-model="isOpenSummaryCorrectiveFactor">
        <v-card class="mx-auto">
            <v-card-title
                primary-title
                class="text-h6 font-weight-regular justify-space-between"
            >
                <v-row>
                    <v-col class="d-flex justify-center" cols="12">
                        <h3 class="font-weight-light primary--text">
                            Factores Establecidos
                        </h3>
                    </v-col>
                </v-row>
                <v-row dense class="d-flex justify-center">
                    <v-col cols="12" md="6" class="d-flex justify-center">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    dark
                                    outlined
                                    color="primary"
                                    v-on="on"
                                    >{{ 'Mes: ' + formatDateToYearMonth(date) }}
                                    <v-icon rigth>mdi-calendar</v-icon>
                                </v-btn>
                            </template>
                            <v-date-picker
                                color="primary"
                                v-model="date"
                                type="month"
                                no-title
                                scrollable
                            >
                                <v-spacer></v-spacer>
                                <v-btn text color="red" @click="menu = false">
                                    Cerrar
                                </v-btn>
                                <v-btn
                                    depressed
                                    text
                                    color="primary"
                                    @click="
                                        searchNewDate(date);
                                        $refs.menu.save(date);
                                    "
                                >
                                    Guardar
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex justify-center">
                        <v-btn
                            depressed
                            @click="openCreate()"
                            color="green darken-2"
                            outlined
                            dark
                            small
                        >
                            Crear Factor
                            <v-icon right>mdi-table-column-plus-before</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-card-text>
                <v-data-table
                    :loading="isLoadingCorrectiveFactors"
                    :headers="headers"
                    :items="correctiveFactors"
                    class="elevation-0"
                    :search="search"
                    :footer-props="footer_props"
                >
                    <template v-slot:top>
                        <v-text-field
                            v-model="search"
                            label="Buscar"
                            class="mx-4"
                        ></v-text-field>
                    </template>
                    <template v-slot:item.created_on="{ item }">
                        {{ formatDateToYearMonth(item.created_on) }}
                    </template>
                    <template v-slot:item.Actions="{ item }">
                        <v-col md="12">
                            <div class="d-flex flex-row justify-space-between">
                                <v-btn
                                    v-if="hasManagerPermission"
                                    fab
                                    @click="openWatch(item)"
                                    x-small
                                    color="primary"
                                    outlined
                                >
                                    <v-icon> mdi-eye </v-icon>
                                </v-btn>
                                <v-btn
                                    v-if="hasAdminPermission"
                                    class="ml-1"
                                    fab
                                    @click="openDeleteDialog(item)"
                                    x-small
                                    color="red"
                                    outlined
                                >
                                    <v-icon> mdi-delete </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions elevation="0" class="justify-end">
                <v-btn
                    text
                    color="red"
                    @click="isOpenSummaryCorrectiveFactor = false"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
        <DeleteDialog />
        <CorrectiveFactorStepper />
        <CorrectiveFactorView />
    </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { clone, formatDateToYearMonth } from '@/util/libUtil.js';
import CorrectiveFactorStepper from '@/components/AreaPersonal/Calculadora/FactorCorrector/correctiveFactorStepper.vue';
import CorrectiveFactorView from '@/components/AreaPersonal/Calculadora/FactorCorrector/correctiveFactorView.vue';
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';

export default {
    data: () => ({
        search: '',
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        headers: [
            {
                text: 'Nombre',
                value: 'commercial.nombre_completo',
                align: 'start',
            },
            { text: 'Fecha', value: 'created_on', align: 'center' },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                width: '10px',
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [10],
        },
    }),
    components: {
        CorrectiveFactorStepper,
        CorrectiveFactorView,
        DeleteDialog,
    },
    computed: {
        isOpenSummaryCorrectiveFactor: {
            get() {
                return this.$store.state.areaPersonal.calculadora
                    .isOpenSummaryCorrectiveFactor;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/isOpenSummaryCorrectiveFactor',
                    value
                );
            },
        },
        tenantInfo() {
            return JSON.parse(localStorage.getItem('tenantInfo'));
        },
        ...mapState('areaPersonal/calculadora', {
            correctiveFactors: (state) => state.correctiveFactors,
            isLoadingCorrectiveFactors: (state) =>
                state.isLoadingCorrectiveFactors,
            dateActualInmutable: (state) => state.dateActualInmutable,
        }),
        ...mapGetters('login', {
            hasAdminPermission: 'hasAdminPermission',
            hasManagerPermission: 'hasManagerPermission',
        }),
    },
    methods: {
        formatDateToYearMonth,
        openWatch(item) {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenViewFactor',
                true
            );
            this.$store.commit('areaPersonal/calculadora/factorView', item);
        },
        openCreate(value) {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenCorrectiveFactor',
                true
            );
        },
        searchNewDate() {
            let params = {
                created_on: this.date,
            };
            if (new Date(this.date) >= this.dateActualInmutable) {
                params = { ...params, is_active: true };
            }
            this.getCorrectiveFactors(params);
        },
        openDeleteDialog(item) {
            let deleteObj = {
                toDeleteId: item.id,
                toDeleteType: 'FACTOR',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
        ...mapActions('areaPersonal/calculadora', ['getCorrectiveFactors']),
    },
    watch: {
        isOpenSummaryCorrectiveFactor: {
            immeditate: true,
            handler: function (newValue, oldValue) {
                if (
                    this.hasManagerPermission &&
                    newValue &&
                    !this.correctiveFactors.length
                ) {
                    let params = {
                        created_on: this.date,
                    };
                    if (new Date(this.date) >= this.dateActualInmutable) {
                        params = { ...params, is_active: true };
                    }
                    this.getCorrectiveFactors(params);
                }
            },
        },
    },
};
</script>








